import { interactionTrackingEvent, TrackingEventName } from '@finn/ua-tracking';

export function trackCTAClick(CTATrackingType?: string): void {
  interactionTrackingEvent(TrackingEventName.CTA_CLICKED, {
    location: 'sticky-cta-panel',
    CTATrackingType,
  });
}
